import Vue from 'vue'
import axios from 'axios'
import cfg from '@/cfg'

const API_URL = cfg.ACCOUNTS_API_URL

axios.defaults.withCredentials = true;

// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = API_URL

// POST with JSON content type
axios.defaults.headers.post['Content-Type'] = 'application/json'

// It gives you easy global access to it instead use import
Vue.prototype.$http = axios.create()

const getDefaultState = () => {
  return {
    PaymentMethods: [],
    DefaultPaymentMethod: null,
    hasDefaultPaymentMethod: false,
  }
}

// initial state
const state = getDefaultState()

export const getters = {
  PaymentMethods: state => state.PaymentMethods,
  DefaultPaymentMethod: state => state.DefaultPaymentMethod,
  hasDefaultPaymentMethod: state => state.hasDefaultPaymentMethod,
}

export const actions = {
  ResetPaymentMethods (context) {
    context.commit('RESET_PAYMENT_METHODS_STATE')
  },
  GetPaymentMethods: async ({ commit }) => {
    let stripeCustomer = null;
    axios
      .get(cfg.ACCOUNTS_API_URL + "s/customers")
      .then((response) => {
        stripeCustomer = response.data;
        return axios.get(
          cfg.ACCOUNTS_API_URL + "s/paymentmethods"
        );
      })
      .then((response) => {
        let pms = response.data;
        if (pms != null) {
          try {
            // find and set default payment method based on customer object
            pms.forEach((element, index) => {
              if (
                element.id ==
                stripeCustomer.invoice_settings.default_payment_method.id
              ) {
                pms[index].default = true;
              }
            });
          } catch (error) {
            pms.forEach((element, index) => {
              pms[index].default = false;
            });
          }
        }
        return pms;
      })
      .then((data) => {
        commit("SET_PAYMENT_METHODS", data)
        commit("SET_DEFAULT_PAYMENT_METHOD", data)
      })
      .catch((error) => {
        console.log(error)
        commit("SET_PAYMENT_METHODS", [])
      });
  },
}

export const mutations = {
  SET_PAYMENT_METHODS(state, paymentMethods) {
    state.PaymentMethods = paymentMethods;
  },
  SET_DEFAULT_PAYMENT_METHOD(state, paymentMethods) {
    try {
      paymentMethods.forEach((element) => {
        if (element.default){
          state.DefaultPaymentMethod = element;
          state.hasDefaultPaymentMethod = true;
        }
      });
    } catch (error) {
      state.DefaultPaymentMethod = null;
      state.hasDefaultPaymentMethod = false;
    }
  },
  RESET_PAYMENT_METHODS_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
